import React, { Fragment } from 'react'

import { ImageMedia } from './ImageMedia'
import { VideoMedia } from './VideoMedia'
import { MediaBlock as MediaBlockType } from '@/payload-types'
import { Props as ImageProps } from '@/ui/atoms/CMSImage'
import { ImagesGridMedia } from '@/ui/blocks/MediaBlock/ImagesGridMedia'

export const MediaBlock: React.FC<ImageProps & MediaBlockType> = (props) => {
  const { className, htmlElement = 'div', resource, type } = props

  const Tag = (htmlElement as any) || Fragment

  return (
    <Tag
      {...(htmlElement !== null
        ? {
            className,
          }
        : {})}
    >
      <div>{type === 'image' && <ImageMedia {...props} className={'w-full h-auto'} />}</div>
      <div>{type === 'gallery' && <ImagesGridMedia {...props} className={'w-full h-auto'} />}</div>
      <div>{type === 'video' && <VideoMedia {...props} />}</div>
    </Tag>
  )
}
